import {BlockMarkup, BlockMarkupItemType, PlainTextMarkup} from "../markup/markup.interface";

export function getPlainText(blockMarkup: BlockMarkup): string {
    return blockMarkup.filter(i => i.type === BlockMarkupItemType.PlainText)
        .map(i => (i as PlainTextMarkup).text.replace(/\*\*/g, ''))
        .join(' ');
}